import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=fe679d24"
import script from "./FolderItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FolderItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports